import React, { Fragment } from 'react';

import useClubFacilities from './UseClubFacilities';

import ClubFacilitiesReadGrid from './ClubFacilitiesReadGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';

const ClubFacilitiesRead = () => {
  const { usasClubFacilityLinksState } = useClubFacilities();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Club Facilities</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <ClubFacilitiesReadGrid />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={usasClubFacilityLinksState.isArrayLoading} />
    </Fragment>
  );
};

export default ClubFacilitiesRead;